import React, { useState } from 'react'
import { Link, useLocation } from 'react-router'
import { useAuth } from '../../auth/AuthContext';
import {useNavigate} from "react-router-dom"

function SideNavbar() {

  const {logout}  = useAuth()
   const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();   
      

  };

const location = useLocation();
const activePath = location.pathname; 

console.log(activePath)

  const [activeNav , setActiveNav] = useState(null);


  return (
    <div className='main-sidebar-bg-color'>

 <div className='main-sidebar-inner-container'>

<div className="sidenavbar-menu-item-List"  >

        <Link to="/auth/v6/dash-board"  className={` ${activePath === "/auth/v6/dash-board" ? "active-dash-bordNav":""}`} ><div>   <i class="fa-solid fa-chart-simple"></i> Dashboard </div></Link>
        <Link to="/auth/v6/dash-board/glazma-reviews-manage"  className={` ${activePath === "/auth/v6/dash-board/glazma-reviews-manage" ? "active-dash-bordNav":""}`} > <div>  <i class="fa-solid fa-tag"></i>  Glazma</div></Link>
        <Link to="/auth/v6/dash-board/goc-reviews-manage"  className={` ${activePath === "/auth/v6/dash-board/goc-reviews-manage" ? "active-dash-bordNav":""}`} > <div>  <i class="fa-solid fa-tag"></i> GOC</div></Link>
        <Link to="/auth/v6/dash-board/fluffytouch-reviews-manage"  className={` ${activePath === "/auth/v6/dash-board/fluffytouch-reviews-manage" ? "active-dash-bordNav":""}`} > <div>  <i class="fa-solid fa-tag"></i> Fluffy Touch </div></Link>
       
           <Link to="/auth/v6/dash-board/bhumu-reviews-manage"  className={` ${activePath === "/auth/v6/dash-board/bhumu-reviews-manage" ? "active-dash-bordNav":""}`} > <div>  <i class="fa-solid fa-tag"></i> BHUMU</div></Link>

         <Link to="/auth/v6/dash-board/settings"  className={` ${activePath === "/auth/v6/dash-board/settings" ? "active-dash-bordNav":""}`} > <div>   <i class="fa-solid fa-gear"></i>   Settings</div></Link>
    
    
    
</div>

<div className='sidebar-ogout-cont' onClick={handleLogout}>

    LogOut<i class="fa-solid fa-right-to-bracket"></i>
</div>

 </div>

    </div>
  )
}

export default SideNavbar